import { ReactElement } from "react";
import { ReactComponent as Authentication } from "./authentication.svg";
import { useTranslation } from "react-i18next";

export type AuthenticationRequiredProps = {
  onAuthenticate: () => void;
};

const AuthenticationRequired = ({
  onAuthenticate,
}: AuthenticationRequiredProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <Authentication />
      <h2 className="my-4 fw-lighter text-black">
        {t("authenticationRequired.heading", "Authentication Required")}
      </h2>
      <p>
        {t(
          "authenticationRequired.instructions1",
          "This process will open in a new tab.",
        )}
      </p>
      <p>
        {t(
          "authenticationRequired.instructions2",
          "Please follow the on-screen instructions.",
        )}
      </p>
      <button
        type="button"
        className="btn btn-lg btn-primary mt-3"
        onClick={onAuthenticate}
      >
        {t("authenticationRequired.authenticateButton", "Authenticate")}
      </button>
    </div>
  );
};

export default AuthenticationRequired;
